// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { ApiHandler, makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Session } from "@insite/client-framework/Services/SessionService";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import {
    chain as SignIn,
    CloseOverlay,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

export const XngGaLogInEvent: HandlerType = async props => {
    const state = props.getState() as xGoogleAnalyticsState;

    const awaitableLoadBillTo = makeHandlerChainAwaitable(loadBillTo);
    let billTo = {} as BillToModel;

    if (props.authenticatedSession) {
        props.dispatch(setSignInOverlayIsOpen({ isOpen: false }));
    }

    await awaitableLoadBillTo({
        billToId: props.authenticatedSession?.billToId || "",
        expand: ["validation"],
        onComplete: result => {
            billTo = result.apiResult as any;
        },
    })(props.dispatch, props.getState);

    if (state.xGoogleAnalytics.includeLoginEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.LOGIN,
            affilliation: billTo?.companyName,
            brand_code: billTo?.properties?.brand,
            exclusive: billTo?.properties?.exclusive,
            group_descr: billTo?.properties?.groupDescription,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

const _GaLogInEvent = XngGaLogInEvent as any;

replaceInChain(SignIn, CloseOverlay, _GaLogInEvent);
